import { cloth, spear } from '../motifs';
import { M, RED } from '../palette';
import type { Pen } from '../pen';
import { registerPlate } from '../registry';

/** A ragged red streamer, `n` units long, waving one way or the other. */
function streamer(p: Pen, n: number, up: boolean): void {
  for (let i = 0; i < n; i++) {
    const y = 1 + Math.round(Math.sin(i * 0.9 + (up ? 0 : Math.PI)) * 1);
    p.rect(i, y, 1, 2 - (i === n - 1 ? 1 : 0), i % 3 ? M.red : M.redHi);
    if (i % 4 === 3) p.px(i, y + 2, M.redLo);
  }
}

/** 08 ผู้ท้าสู้: the challenger's plate, dark lacquer under torn red cloth, a spear at each end. */
registerPlate({
  id: 'challenger',
  name: 'ผู้ท้าสู้',
  ground: ['#3c1e24', '#24121a', '#160a10'],
  trim: M.red,
  text: { fill: ['#ffe0d0', '#f0a090'], line: '#120608' },
  inset: [14, 15],
  front(p, f) {
    spear(p, f.x + 2, f.y - 15, f.b + 8, -2);
    spear(p, f.r - 2, f.y - 15, f.b + 8, 2);
    cloth(p, f.x - 3, f.y - 2, 15, 19, RED, 1);
    cloth(p, f.r - 13, f.y - 2, 16, 23, RED, 3);
    p.rect(f.x - 3, f.y - 2, 15, 1, M.redLo).rect(f.r - 13, f.y - 2, 16, 1, M.redLo);
  },
  motion: {
    sprites: {
      flyA: { w: 8, h: 4, draw: (p) => streamer(p, 8, true) },
      flyB: { w: 8, h: 4, draw: (p) => streamer(p, 8, false) },
    },
    play(a, t, f) {
      // Streamers off the spear heads, fluttering.
      const n = Math.floor(t * 6) % 2;
      a.spr(n ? 'flyA' : 'flyB', f.r + 1, f.y - 9);
      a.spr(n ? 'flyB' : 'flyA', f.x - 8, f.y - 9);
    },
  },
});
